
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riverpro-firmware-update",
      function () {
        return require("private-next-pages/riverpro-firmware-update/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riverpro-firmware-update"])
      });
    }
  